export default "__VITE_ASSET__51590eca__"